import { ApexOptions } from 'apexcharts';
import { FC, useMemo } from 'react';
import Chart from 'react-apexcharts';

export const blueScaleOrder = [900, 800, 700, 600, 500, 400, 300, 200, 100, 50];

export const blueScale: Record<number, string> = {
  900: '#1D2540',
  800: '#23304F',
  700: '#2A3C5F',
  600: '#30496E',
  500: '#36577D',
  400: '#55769B',
  300: '#7796B6',
  200: '#9BB5CE',
  100: '#C2D4E4',
  50: '#ECF2F7',
};

export type DonutSlice = {
  value: number;
  label: string;
  colour?: string;
  textColour?: string;
};

export interface IProps {
  slices: DonutSlice[];
  height?: number | string;
  width?: number | string;
  tooltipFormatter?: (value: number) => string;
  options?: ApexOptions;
}

const DonutChart: FC<IProps> = (props) => {
  const {
    slices,
    options,
    height = 230,
    width = 230,
    tooltipFormatter,
  } = props;

  const sliceColours = useMemo(() => {
    const blueScaleInOrder = blueScaleOrder.map((i) => blueScale[i]);
    const len = blueScaleInOrder.length;

    return slices.map((slice, i) => {
      if (slice.colour) return slice.colour;
      const colourIndex = ((i % len) + len) % len;
      return blueScaleInOrder[colourIndex];
    });
  }, [slices]);

  return (
    <Chart
      options={{
        chart: {
          fontFamily: 'Inter, "Noto Color Emoji", sans-serif',
        },
        grid: {
          padding: {
            top: -4,
            bottom: -4,
            left: -4,
            right: -4,
          },
        },
        stroke: {
          width: 5,
          colors: ['rgb(255, 255, 255)'],
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            },
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: '50%',
            },
          },
        },
        labels: slices.map((s) => s.label),
        colors: sliceColours,
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          ...(tooltipFormatter
            ? {
                y: {
                  formatter: tooltipFormatter,
                },
              }
            : {}),
        },
        ...options,
      }}
      series={slices.map((s) => s.value)}
      type="donut"
      width={width}
      height={height}
    />
  );
};

export default DonutChart;
